import type {
  AccountEntryRow,
  AccountEntryRowAdjustments,
  AccountEntryRowChild,
  AccountEntryRowGroup,
  AccountEntryWithoutSubsidiaries,
} from './types'

export function isAccountEntryRowGroup(
  entry: AccountEntryRow
): entry is AccountEntryRowGroup {
  return (entry as AccountEntryRowGroup).group !== undefined
}

export function isAccountEntryRowChild(
  entry: AccountEntryRow
): entry is AccountEntryRowChild {
  return (
    (entry as AccountEntryRowChild).groupBy !== undefined &&
    (entry as AccountEntryRowChild).subsidiaryName !== undefined
  )
}

export function isAccountEntryRowAdjustments(
  entry: AccountEntryRow
): entry is AccountEntryRowAdjustments {
  return (
    (entry as AccountEntryRowAdjustments).adjustmentsValue !== undefined &&
    !(entry as AccountEntryRowChild).subsidiaryName
  )
}

export function isAccountEntryRowPlain(
  entry: AccountEntryRow
): entry is AccountEntryWithoutSubsidiaries {
  return !isAccountEntryRowGroup(entry) && !isAccountEntryRowChild(entry)
}
